import { render, staticRenderFns } from "./FilterMenuSpendings.vue?vue&type=template&id=657a5f37&scoped=true&"
import script from "./FilterMenuSpendings.vue?vue&type=script&lang=js&"
export * from "./FilterMenuSpendings.vue?vue&type=script&lang=js&"
import style0 from "./FilterMenuSpendings.vue?vue&type=style&index=0&id=657a5f37&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657a5f37",
  null
  
)

export default component.exports